import { useEffect, useState } from "react";
import Pagetitle from "./component/Pagetitle";
import { useNavigate } from "react-router-dom";
import { useApiStore } from "./hooks/ApiStoreContext";
import AddressManagement from "./AddressManagement";
import { useCart } from "./hooks/CartContext";

function Checkout() {
  const apiStore = useApiStore();
  const {clearCart} = useCart();
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0.0);
  const [sTotal, setSTotal] = useState(0.0);
  const [totalGSTAmount, setTotalGSTAmount] = useState(0.0);
  const [ignoreBindCart, setIgnoreBindCart] = useState(false);
  const [selectedDeliveryAddressId, setSelectedDeliveryAddressId] = useState(null);
  const [selectedBillingAddressId, setSelectedBillingAddressId] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponId, setCouponId] = useState(null);
  const [couponValidationAttempted, setCouponValidationAttempted] = useState(false);
  const [isOrderPlacementInProgress, setIsOrderPlacementInProgress] = useState(false);

  useEffect(() => {
    if (!ignoreBindCart) {
      bindCartItems();
      setIgnoreBindCart(true);
    }

    if (!isCouponApplied) {
      updateSubTotal();
    }
  });

  const updateSubTotal = () => {
    let st = 0.0;
    let gstAmount = 0.0;
    let t = 0.0;
    tableData.forEach((row) => {
      st += row.priceAfterDiscount * row.quantity;
      gstAmount += row.gstAmountAfterDiscount * row.quantity;
      t += row.total;
    });
    setSTotal(st);
    setTotalGSTAmount(gstAmount);
    setTotal(t);
  };

  const bindCartItems = async () => {
    try {
      let loginUserId = localStorage.getItem("geniusBabySiteUserId");
      if (!loginUserId) {
        navigate("/login");
        return;
      }

      const data = await apiStore.get(`/users/GetCartItems?userId=${Number(loginUserId)}`);
      setTableData(data);
    } catch (error) {
      console.error("Error getting cart:", error);
      if (error.status === 401) {
        navigate("/login");
      }
    }
  };

  const handleDiscount = async (e) => {
    e.preventDefault();

    const loginUserId = localStorage.getItem("geniusBabySiteUserId");
    if (!loginUserId) {
      navigate("/login");
      return;
    }

    try {
      setCouponValidationAttempted(true);
      const response = await apiStore.get(`/coupon/ValidateCoupon?code=${couponCode}&userId=${Number(loginUserId)}`);
      if (response) {
        setIsCouponApplied(true);
        setCouponId(response.couponId);

        let newSubTotal = 0.0;
        let gstAmount = 0.0;

        tableData.forEach((row) => {
          let newDiscountAmount = (row.priceAfterDiscount * response.discountPercent) / 100;
          let newPriceAfterDiscount = row.priceAfterDiscount - newDiscountAmount;
          let newGSTAmountAfterDiscount = (newPriceAfterDiscount * row.gstPercentage) / 100;

          newSubTotal += newPriceAfterDiscount * row.quantity;
          gstAmount += newGSTAmountAfterDiscount * row.quantity;
        });

        const discountAmt = sTotal - newSubTotal;
        setDiscountAmount(discountAmt);
        setTotalGSTAmount(gstAmount);
        let newOrderTotal = newSubTotal + gstAmount;
        setTotal(newOrderTotal);
      } else {
        handleInvalidCoupon();
      }
    } catch (error) {
      if (error.status === 404) {
        handleInvalidCoupon();
      } else {
        console.error("Error validating coupon:", error);
        alert("Error validating coupon");
      }
    }
  };

  const handleInvalidCoupon = () => {
    setIsCouponApplied(false);
    setDiscountAmount(0);
    updateSubTotal();
  };

  const handlePlaceOrder = async (e) => {
    e.preventDefault();
    if (isOrderPlacementInProgress) return;
    try {
      let loginUserId = localStorage.getItem("geniusBabySiteUserId");
      if (!loginUserId) {
        navigate("/login");
        return;
      }

      if (!tableData.length) {
        alert("No items in cart to place order");
        return;
      }

      if (!selectedDeliveryAddressId) {
        alert("Please select a delivery address to continue.");
        return;
      }

      if (!selectedBillingAddressId) {
        alert("Please select a billing address to continue.");
        return;
      }

      setIsOrderPlacementInProgress(true);

      const orderDto = {
        createdDate: new Date(),
        createdBy: loginUserId,
        updatedDate: new Date(),
        updatedBy: loginUserId,
        orderId: 0,
        userId: loginUserId,
        orderDate: new Date(),
        deliveryAddressId: selectedDeliveryAddressId,
        billingAddressId: selectedBillingAddressId,
        couponId: isCouponApplied ? couponId : null,
        subTotal: sTotal, //Price before discount coupon
        totalAmount: total, //price after discount coupon
        orderStatus: 1, //OrderPlaced
        paymentStatus: 1, //Pending
        gstAmount: totalGSTAmount, //new
        orderItems: tableData.map((item) => ({
          createdDate: new Date(),
          createdBy: loginUserId,
          updatedDate: new Date(),
          updatedBy: loginUserId,
          orderItemId: 0,
          orderId: 0,
          productId: item.productId,
          price: item.price,
          discountPercentage: item.discountPercentage,
          priceAfterDiscount: item.priceAfterDiscount, //new
          gstPercentage: item.gstPercentage,
          quantity: item.quantity,
        })),
      };

      const response = await apiStore.post("/order", orderDto);
      console.log(response);
      alert("Order raised successfully");
      clearCart();
      navigate("/my-account-orders");
    } catch (error) {
      console.error("Error placing order:", error);
      setIsOrderPlacementInProgress(false);
      // Handle error
    }
  };

  return (
    <>
      <Pagetitle title="Check Out" />
      <section className="flat-spacing-11">
        <div className="container">
          <div className="tf-page-cart-wrap layout-2">
            <div className="tf-page-cart-item">
              <h5 className="fw-5 mb_20">Billing details</h5>
              <AddressManagement selectOnly={true} onSelectDeliveryAddress={(address) => setSelectedDeliveryAddressId(address.addressId)} onSelectBillingAddress={(address) => setSelectedBillingAddressId(address.addressId)}></AddressManagement>
            </div>
            <div className="tf-page-cart-footer">
              <div className="tf-cart-footer-inner">
                <h5 className="fw-5 mb_20">Your order</h5>
                <form className="tf-page-cart-checkout widget-wrap-checkout">
                  <ul className="wrap-checkout-product">
                    {tableData.map((item, i) => {
                      return [
                        <li key={item.cartId} className="checkout-product-item">
                          <figure className="img-product">
                            <img src={item.productImageUrl} alt="product" />
                            <span className="quantity">{item.quantity}</span>
                          </figure>
                          <div className="content">
                            <div className="info">
                              <p className="name">{item.productName}</p>
                              <span className="variant">{item.productVariant}</span>
                            </div>
                            <span className="price">₹{item.priceAfterDiscount * item.quantity}</span>
                          </div>
                        </li>,
                      ];
                    })}
                  </ul>
                  <div className="d-flex justify-content-between line pb_20">
                    <h6 className="fw-5">Subtotal</h6>
                    <h6 className="total fw-5">₹{sTotal.toFixed(2)}</h6>
                  </div>
                  <div className="coupon-box">
                    <input
                      type="text"
                      placeholder="Discount code"
                      value={couponCode}
                      onChange={(e) => {
                        setCouponCode(e.target.value);
                        setCouponValidationAttempted(false);
                      }}
                    />
                    <a className="tf-btn btn-sm radius-3 btn-fill btn-icon animate-hover-btn" onClick={handleDiscount}>
                      Apply
                    </a>
                  </div>
                  <div className="d-flex justify-content-between line pb_20">
                    <div>{isCouponApplied ? <p style={{ color: "green", marginLeft: "1px" }}>Discount applied: ₹{discountAmount.toFixed(2)}</p> : couponValidationAttempted && discountAmount === 0 && couponCode !== "" ? <p style={{ color: "red", marginLeft: "1px" }}>Invalid coupon code</p> : null}</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <h6 className="fw-5" style={{ fontStyle: "italic", fontSize: "1.0em" }}>
                      GST
                    </h6>
                    <h6 className="total fw-5" style={{ fontStyle: "italic", fontSize: "1.0em" }}>
                      + ₹{totalGSTAmount.toFixed(2)}
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between line pb_20">
                    <h6 className="fw-5">Order Total</h6>
                    <h6 className="total fw-5">₹{total.toFixed(2)}</h6>
                  </div>
                  <button
                    className="tf-btn radius-3 btn-fill btn-icon animate-hover-btn justify-content-center"
                    style={{
                      opacity: isOrderPlacementInProgress ? 0.5 : 1,
                      cursor: isOrderPlacementInProgress ? "not-allowed" : "pointer",
                    }}
                    onClick={handlePlaceOrder}
                    disabled={isOrderPlacementInProgress} // Disable button when order placement is in progress
                  >
                    {isOrderPlacementInProgress ? "Placing order..." : "Place order"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Checkout;
